import Vue from "vue";

// import Vuetify, {
//   VApp,
//   VAppBar,
//   VAppBarNavIcon,
//   VContent,
//   VContainer,
//   VRow,
//   VCol,
//   VSpacer,
//   VBtn,
//   VIcon,
//   VLayout,
//   VList,
//   VNavigationDrawer,
//   VListItem,
//   VListItemAction,
//   VDivider,
//   VListItemContent,
//   VListItemTitle,
//   VListGroup,
//   VAlert,
//   VForm,
//   VTextField
// } from "vuetify/lib";
import Vuetify from "vuetify/lib";
Vue.use(Vuetify, {
  // components: {
  //   VApp,
  //   VAppBar,
  //   VAppBarNavIcon,
  //   VContent,
  //   VContainer,
  //   VRow,
  //   VCol,
  //   VSpacer,
  //   VBtn,
  //   VIcon,
  //   VLayout,
  //   VList,
  //   VNavigationDrawer,
  //   VListItem,
  //   VListItemAction,
  //   VDivider,
  //   VListItemContent,
  //   VListItemTitle,
  //   VListGroup,
  //   VAlert,
  //   VForm,
  //   VTextField
  // }
});

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#db2828",
        error: "#D50000",
        anchor: "rgba(0, 0, 0, 0.87)"
      }
    }
  }
});
